import Words from './words';
import Verbs from './verbs';
import Sentences from './sentences';

export { Words, Verbs, Sentences };

export default { Words, Verbs, Sentences };
